import Supercluster from 'supercluster'
import { EstablishmentGeoJsonFeatureProperties } from '../types'

type Cluster = Supercluster.ClusterFeature<Supercluster.ClusterProperties>

type Feature = Supercluster.PointFeature<EstablishmentGeoJsonFeatureProperties>

const isCluster = (feature: Cluster | Feature): feature is Cluster => {
  return 'cluster' in feature.properties
}

export { isCluster }
